/**
 * PendingApprovals — focal panel listing every pending-approval order.
 * Each is rendered as an ApprovalCard with Approve/Reject buttons.
 */
import { ApprovalCard } from './ApprovalCard';
import { usePending } from '../lib/usePending';

export function PendingApprovals() {
  const { orders, refresh } = usePending();
  if (orders.length === 0) {
    return (
      <div className="text-xs text-ink-mute">
        no pending approvals. Every order you place will pause here for your click,
        unless your <code className="num text-ink">Settings → Approval policy</code> says
        to auto-approve it.
      </div>
    );
  }
  return (
    <div className="space-y-3 max-w-2xl">
      <div className="text-xs text-ink-mute">
        {orders.length} order{orders.length === 1 ? '' : 's'} awaiting your approval.
        Click Approve to send to the broker, Reject to cancel, or wait for auto-expiry.
      </div>
      {orders.map((o) => (
        <ApprovalCard key={o.client_order_id ?? o.id ?? Math.random()} order={o} onUpdate={() => refresh()} />
      ))}
    </div>
  );
}
